import { MaterialFileFormFields } from "@/components/commonFormItems/MaterialFileFormFields";
import { SupplierInfoFormItems } from "@/components/commonFormItems/SupplierInfoFormItems";
import ModalSectionHeader from "@/components/ui/ModalSectionHeader";
import { BLACKLIST_APPLY_TYPE } from "@/constants";
import { useModal } from "@/hooks/modals/useModal";
import { Col, Form, Input, Row } from "antd";
import { FormInstance } from "antd/lib";
import { useTranslation } from "react-i18next";
import { useBlacklistRecordDetail } from "../hooks/useBlacklistRecordDetail";
import { useFormEditable } from "../hooks/useFormEditable";
import type { BlacklistApplyFormFields } from "../type";

type Props = {
  form: FormInstance<BlacklistApplyFormFields>;
};

export function BlacklistApplyForm({ form }: Props) {
  const { t } = useTranslation("blacklist");
  const { props } = useModal("SUPPLIER_BLACK_LIST");
  const { recordId, flowStatus } = props;

  const { isAddToEditable, isRemoveFromEditable } = useFormEditable();

  const detail = useBlacklistRecordDetail(recordId);

  // 是否显示移出黑名单原因
  const showRemoveFromReason =
    detail?.applyType === BLACKLIST_APPLY_TYPE.REMOVE_FROM ||
    (flowStatus === "已通过" &&
      detail?.applyType === BLACKLIST_APPLY_TYPE.ADD_TO);

  const hiddenRemove =
    !detail ||
    (flowStatus !== "已驳回" &&
      detail?.applyType === BLACKLIST_APPLY_TYPE.ADD_TO);

  return (
    <Form
      form={form}
      layout="vertical"
      disabled={!isAddToEditable}
      style={{ paddingRight: 26 }}
    >
      <div>
        <ModalSectionHeader title={t("供应商信息")} />
        <SupplierInfoFormItems<BlacklistApplyFormFields> />

        <Row>
          <Col span={24}>
            <Form.Item<BlacklistApplyFormFields>
              label={t("移入黑名单原因")}
              name="blacklistReason"
              rules={[{ required: true, message: t("请输入移入黑名单原因") }]}
            >
              <Input.TextArea placeholder={t("请输入")} maxLength={300} />
            </Form.Item>
          </Col>
        </Row>

        <MaterialFileFormFields
          required={false}
          label={t("相关证明文件")}
          fieldName="files"
          bindFlow={true}
          hiddenRemove={hiddenRemove}
        />
      </div>

      {showRemoveFromReason && (
        <div>
          <ModalSectionHeader title={t("移出黑名单原因")} />
          <Row>
            <Col span={24}>
              <Form.Item<BlacklistApplyFormFields>
                label=""
                name="removeBlacklistReason"
                rules={[{ required: true, message: t("请输入移出黑名单原因") }]}
              >
                <Input.TextArea
                  placeholder={t("请输入")}
                  maxLength={300}
                  disabled={!isRemoveFromEditable}
                />
              </Form.Item>
            </Col>
          </Row>
        </div>
      )}
    </Form>
  );
}
